import { Injectable } from '@angular/core';
import { DatabaseModel } from '../../../features/database-model/models/class/database-model.class';
import { MODEL } from '../../constant/local-storage.constant';
import { DatabaseModelBuilder } from '../../../features/database-model/models/builder/database-model-builder.class';
import { SavedDatabaseModel } from '../../../features/database-model/models/saved/saved-database-model.type';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  private readonly _TOKEN_KEY = 'token';

  public saveModel(model: DatabaseModel): void {
    const savedModel = DatabaseModelBuilder.buildToSaved(model);
    localStorage.setItem(MODEL, JSON.stringify(savedModel));
  }

  public loadModel(): DatabaseModel {
    const storedModel = localStorage.getItem(MODEL);
    let model: DatabaseModel = DatabaseModelBuilder.buildEmptyModel();

    if (storedModel != null) {
      const savedModel: SavedDatabaseModel = JSON.parse(storedModel);
      model = DatabaseModelBuilder.buildFromSavedDto(savedModel);
    }

    return model;
  }

  public setToken(token: string): void {
    localStorage.setItem(this._TOKEN_KEY, token);
  }

  public getToken(): string | null {
    return localStorage.getItem(this._TOKEN_KEY);
  }

  public removeToken(): void {
    localStorage.removeItem(this._TOKEN_KEY);
  }
}
